import React, { Component } from "react";
import Dashboardpage from "../../Components/Seller/Dashboard";

export class Dashboard extends Component {
  componentDidMount() {
    const {
      TotalRevenueRequest,
      TotalActiveProductsRequest,
      getRecentOrdersRequest,
      getlowStockProductsRequest,
    } = this.props;
    TotalRevenueRequest();
    TotalActiveProductsRequest();
    getRecentOrdersRequest();
    getlowStockProductsRequest();
  }
  render() {
    const {
      totalActiveProductCount,
      totalRevenue,
      RecentOrders,
      lowStockProducts,
    } = this.props;
    return (
      <>
        <Dashboardpage
          totalActiveProductCount={totalActiveProductCount}
          totalRevenue={totalRevenue}
          RecentOrders={RecentOrders}
          lowStockProducts={lowStockProducts}
        />
      </>
    );
  }
}

export default Dashboard;
